import { render, staticRenderFns } from "./OnboardFormWizard.vue?vue&type=template&id=48aa8160&scoped=true&"
import script from "./OnboardFormWizard.vue?vue&type=script&lang=js&"
export * from "./OnboardFormWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aa8160",
  null
  
)

export default component.exports